import React, { useEffect } from "react"

import BriefContact from "./BriefContact"
import BriefAssets from "./BriefAssets"
import BriefFinish from "./BriefFinish"

import { BriefFormModel } from "../../models/blocks"

export interface FullFormProps extends BriefFormModel {
  step: number
  formFunctions: any
  handleBackStep: () => void
  handleNextStep: () => void
}

const defaultProps = {}

const ShortForm: React.FC<FullFormProps> = props => {
  useEffect(() => {
    scrollTo({ top: 0 })
  }, [props.step])

  return (
    <>
      <BriefContact
        show={props.step === 1}
        content={props.stepContent_contact}
        formFunctions={props.formFunctions}
        handleBackStep={props.handleBackStep}
        handleNextStep={props.handleNextStep}
      />

      <BriefAssets
        show={props.step === 2}
        brandAssets={props.stepContent_brandAssets}
        creativeAssets={props.stepContent_creativeAssets}
        formFunctions={props.formFunctions}
        handleBackStep={props.handleBackStep}
        handleNextStep={props.handleNextStep}
      />

      <BriefFinish show={props.step === 3} content={props.finish} />
    </>
  )
}

ShortForm.defaultProps = defaultProps

export default ShortForm
